var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutoCursor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "asset=AutoCursor, colour=Cursor, htmlTag=img, assetKey=Content"
  }, /*#__PURE__*/React.createElement("path", {
    id: "content4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.87972 18.9028V2.88782L18.4707 14.5068H11.6897L11.2787 14.6308L6.87972 18.9028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "content3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9642 19.5771L12.3592 21.1121L7.67721 10.0231L11.3632 8.47009L15.9642 19.5771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "content2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6307 18.8965L12.7867 19.6705L9.68673 12.2965L11.5277 11.5215L14.6307 18.8965Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "content1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.87972 5.29492V16.4829L10.8487 13.6169L11.2767 13.4779H16.0447L7.87972 5.29492Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoCursor);
export default __webpack_public_path__ + "static/media/AutoCursor.f4fd02c4f4548c89399b52991c48cf67.svg";
export { ForwardRef as ReactComponent };